import React from 'react'
import { Header2, Text } from '../../styles/Components'

const Cancellation = () => {
  return (
    <div className='section-wrapper cancellation'>
      <Header2 margin='0 0 18px 0'>
        Need to cancel?
      </Header2>
      <div className='text-and-link'>
        <Text lineHeight='138%' spacing={0.96}>
          Sometimes life gets in the way.&nbsp;
        </Text>
        <a href='https://help.glamsquad.com/en-US/what-is-the-glamsquad-cancellation-policy-166906'>
          See our cancellation policy here.
        </a>
      </div>
      <div className='text-and-link'>
        <Text lineHeight='138%' spacing={0.96}>
          If you&apos;ve got more questions,&nbsp;
        </Text>
        <a href='https://help.glamsquad.com/en-US'>
          check out our FAQs.
        </a>
      </div>
    </div>
  )
}

export default Cancellation
